@if (loading) {
  <p>Ihre Daten werden geladen.</p>
}
@if (!loading) {
  <app-password (success)="credentialsSet($event)"
    [token]="token"
    [credentialsService]="passwordRestService"
    [type] = "'reset'"
    >
  </app-password>
}
